// Formats a UTC instant (ISO string, e.g. "2026-06-29T22:00:00Z") into the shop's wall-clock
// date and time by formatting in the configured business IANA time zone, NOT the browser's.
// This is why the same shipping cutoff shows "18:00" to every operator regardless of locale.
export function formatAvailableDate(iso: string, timeZone: string): { date: string; time: string } {
    const instant = new Date(iso);
    const date = new Intl.DateTimeFormat('ru-RU', {
        timeZone,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(instant);
    const time = new Intl.DateTimeFormat('ru-RU', {
        timeZone,
        hour: '2-digit',
        minute: '2-digit',
    }).format(instant);
    return { date, time };
}
